import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AuthenticationRequirementsModule = () => (
  <QPhototModuleSubtopic
    title="Authentication Requirements, Authentication Functions, Message Authentication Codes"
    videos={[
      "https://www.youtube.com/embed/4lVaf-fCYdE",
      "https://www.youtube.com/embed/Xb_84P8Y7JI"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);

export default AuthenticationRequirementsModule;
